import { Box, Heading, Separator } from "@chakra-ui/react-v3";
import { ISO_DATE } from "@metriport/shared/common/date";
import dayjs from "dayjs";
import { WithExtension } from "../components/resource-documents";
import { ResourceAnalysis } from "../components/resource-analysis";
import { SeriesChart } from "../components/series-chart";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { createPairedBloodPressureResources } from "../tables/vital/blood-pressure";
import { VitalRowData } from "../tables/vital";

export type VitalSidePanelContentProps = {
  data: VitalRowData;
};

export function VitalSidePanelContent({ data }: VitalSidePanelContentProps) {
  const series = data.originalData;
  const shouldShowChart = series.resources.length > 1;

  // For blood pressure, pair systolic/diastolic observations for document display
  const isBloodPressure = series.code === "blood-pressure-combined";
  const documentResources: WithExtension[] = isBloodPressure
    ? createPairedBloodPressureResources(series)
    : (series.resources as WithExtension[]);

  return (
    <SidePanelLayout
      title="Vital Sign"
      subtitle={data.observation}
      metadata={`${series.resources.length} readings • ${dayjs(series.earliestDate).format(
        ISO_DATE
      )} to ${dayjs(series.latestDate).format(ISO_DATE)}`}
    >
      <ResourceAnalysis />

      {shouldShowChart && (
        <>
          <Separator borderColor="border" />
          <Box>
            <Heading size="md" mb={4} color="fg">
              Trend Over Time
            </Heading>
            <Box p={4} borderWidth="1px" borderColor="border" borderRadius="md" bg="bg.subtle">
              <SeriesChart
                series={series}
                chartSeries={data.chartSeries}
                yAxisLabel="Value"
                height={300}
                width={600}
              />
            </Box>
          </Box>
        </>
      )}

      <Separator borderColor="border" />

      <DocumentsSection resources={documentResources} resourceType="Observation" />
    </SidePanelLayout>
  );
}
